export const DATA_INPUT = 'DATA_INPUT';
export const EDIT_FILE = 'Edit File';
